import { StarIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

interface RatingProps {
  stars: number;
  starSize?: 'small' | 'medium' | 'large';
  className?: string;
}

export const Rating = ({ stars, starSize = 'medium', className }: RatingProps) => {
  // Map starSize to actual pixel values
  const sizeMap = { small: 12, medium: 16, large: 20 };

  const iconSize = sizeMap[starSize];

  return (
    <div
      className={cn(
        'flex h-4 items-center justify-start [&_svg]:fill-yellow-400 [&_svg]:text-yellow-400',
        className
      )}
      role="img"
      aria-label={`Rating: ${stars} out of 5 stars`}
    >
      {Array.from({ length: 5 }).map((_, index) => (
        <StarIcon
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          size={iconSize}
          className={cn('transition-colors', { 'opacity-25': index >= stars })}
        />
      ))}
    </div>
  );
};
